import { FarmerFieldsStates, Service } from "@helpers/ui_helper";
import moment from "jalali-moment";
import { Button } from "antd";
import { CloseOutlined, EyeOutlined } from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteFields } from "../../../services/api";
import Swal from "sweetalert2";
import AgroMapFarm from "../../../features/map/presentation/components/AgroMapFarm";
import { toolbarBaseControls } from "../../../features/map/utils/configs";
import { FieldMarkerIcon } from "../../../components/map/utils/customs";
import { areaCalculation } from "../../../features/map/utils/area-calculation";
import { useNavigate } from "react-router-dom";

function FieldCard({ field, setFarmerFieldsState }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const deleteFieldMutation = useMutation({
    mutationFn: deleteFields,
    onSuccess: () => {
      queryClient.invalidateQueries("fields");
    },
  });

  return (
    <div className="box-shadow p-[6px] !rounded-[16px] w-fit h-fit mb-8 relative">
      <div className="inner-circle-neo p-3 w-fit agrobg !rounded-[16px] justify-between flex max-lg:flex-col-reverse items-center">
        <div className="flex-col w-[70%] max-lg:w-full self-stretch justify-between items-center px-2 max-lg:p-0 gap-2 flex ">
          <div className="flex flex-wrap w-[500px] max-lg:w-full h-full p-2 justify-between items-stretch gap-4 max-lg:gap-2">
            <div className="w-[48%] max-lg:w-full max-lg:justify-between gap-4 items-center flex flex-row ">
              <p className="text-right whitespace-nowrap text-agrotext text-base max-lg:text-[12px] font-semibold">
                نام زمین:
              </p>
              <p className="text-center text-agrotext text-base max-lg:text-[14px] font-normal">
                {field?.name}
              </p>
            </div>

            <div className="w-[48%] max-lg:w-full max-lg:justify-between gap-4 items-center flex">
              <p className="30 text-right whitespace-nowrap text-agrotext text-base max-lg:text-[12px] font-semibold">
                مساحت زمین:
              </p>
              <p className=" text-center whitespace-nowrap text-agrotext text-base max-lg:text-[14px] font-normal">
                {areaCalculation(field?.area)}
              </p>
            </div>

            <div className="w-[48%] max-lg:w-full max-lg:justify-between gap-4 items-center flex">
              <p className="text-right text-agrotext text-base max-lg:text-[12px] font-semibold">
                نوع مالکیت:
              </p>
              <p className="text-center text-agrotext text-base max-lg:text-[14px] font-normal">
                {field?.ownershipType?.name}
              </p>
            </div>

            <div className="w-[48%] max-lg:w-full max-lg:justify-between gap-4 items-center flex">
              <p className="16 text-right text-agrotext text-base max-lg:text-[12px] font-semibold">
                تاریخ ثبت:
              </p>
              <p className=" text-center text-agrotext text-base max-lg:text-[14px] font-normal">
                {field?.createdAt &&
                  moment(field?.createdAt, "YYYY/MM/DD")
                    .locale("fa")
                    .format("YYYY/MM/DD")}
              </p>
            </div>
          </div>

          <div className="flex flex-row gap-4">
            <Button
              onClick={() =>
                setFarmerFieldsState({
                  service: Service.HistoricalMaps,
                  state: FarmerFieldsStates.FieldCertificate,
                  fieldObject: field,
                  defaultData: field,
                })
              }
              className="button-green hover:brightness-110 font-bold !border-slate-200 lg:w-[340px] max-lg:px-16 text-base max-lg:text-xs !text-white h-10"
              icon={<EyeOutlined />}
            >
              شناسنامه زمین
            </Button>

            <CloseOutlined
              onClick={() => {
                Swal.fire({
                  icon: "warning",
                  title: "حذف  کلی زمین",
                  text: "زمین شما به طور کلی حذف خواهد شد. آیا از حذف زمین خود اطمینان دارید؟",
                  confirmButtonText: " حذف برای همیشه",
                  confirmButtonText:
                    '<span style="color: red">حذف برای همیشه</span>',
                  cancelButtonText: "لغو",
                  showCancelButton: true,
                }).then((result) => {
                  if (result.isConfirmed) {
                    deleteFieldMutation.mutate(field.id);
                  } else {
                  }
                });
              }}
              className="absolute text-red-600 top-3 max-lg:top-2 right-3 max-lg:right-2"
            />
          </div>
        </div>

        <div
          onClick={() => {
            navigate(`/my-fields/map?id=${field.id}`, {
              replace: true,
              state: {
                fieldObject: field,
                service: Service.MyFields,
                state: FarmerFieldsStates.MapPolygonView,
                default: field,
              },
            });
          }}
          className="relative flex-col cursor-pointer !w-[180px] h-[180px] max-lg:!w-full max-lg:h-[16rem] justify-start items-center gap-4 inline-flex hover:brightness-125 duration-300 "
        >
          <div className="THISISFORMAPLOCK! !z-[999999999] bg-transparent w-full h-full absolute"></div>
          <div className=" w-full pointer-events-none h-full rounded-lg border-2 border-slate-300 flex-col justify-center items-center flex">
            <AgroMapFarm
              mapId={field?.id}
              type="onlyShow"
              toolbarOptions={toolbarBaseControls}
              markerIcon={FieldMarkerIcon}
              currentFarmPolygon={field?.polygon}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FieldCard;
